import { object } from 'zod';
import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import {
  DateSchema,
  TimeSchema,
} from '@occc-app/routes/CampaignComponents/components/ScheduleDates/schemas/schedule-dates.schema';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { buildValidateDateAndTimeBothSet } from '@occc-app/routes/CampaignComponents/components/ScheduleDates/schemas/build-validate-date-and-time-both-set';
import { validatePublishBeforeExpire } from '@occc-app/routes/CampaignComponents/components/ScheduleDates/schemas/validate-publish-before-expire';

export const scheduleFormSchema = object({
  publishAtDate: DateSchema.refine((date) => !!date, { message: IS_REQUIRED }),
  publishAtTime: TimeSchema.refine((time) => !!time, { message: IS_REQUIRED }),
  expireAtDate: DateSchema,
  expireAtTime: TimeSchema,
})
  .superRefine(buildValidateDateAndTimeBothSet('expire'))
  .superRefine(validatePublishBeforeExpire);

export const validateSurveyScheduleForm = makeValidate(scheduleFormSchema);
